import { render, staticRenderFns } from "./findPlateNumber.vue?vue&type=template&id=1345d5e9&scoped=true&"
import script from "./findPlateNumber.vue?vue&type=script&lang=js&"
export * from "./findPlateNumber.vue?vue&type=script&lang=js&"
import style0 from "./findPlateNumber.vue?vue&type=style&index=0&id=1345d5e9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345d5e9",
  null
  
)

export default component.exports